module.exports = __webpack_public_path__ + "static/media/PZ_3_etapa.f91ad40e.jpg";